module.exports = __webpack_public_path__ + "static/media/bats-row.253228a1.png";